import { useQuery, UseQueryResult } from 'react-query';
import { TaxRate } from 'types';
import { client } from 'utils/api-client';

function useTaxRate(taxRateId: string | undefined): UseQueryResult<{ data: TaxRate }> {
  return useQuery(['taxRates', taxRateId], () => client.get(`tax-rates/${taxRateId}/`), {
    enabled: !!taxRateId,
  });
}

export default useTaxRate;
